import styled from 'styled-components';

export const SkeletonContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: space-between;
`;

export const SkeletonItem = styled.div`
  width: 172px;
`;

export const GraphContainer = styled.div<{ complete: boolean }>`
  & .hefesto-simple-graph--danger .hefesto-simple-graph__bar {
    background-color: ${({ complete }) => (complete ? '#477237' : '#E17915')};
  }
`;

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1rem;

  padding: 2rem 1.5rem;
  margin: 8px auto 0px auto;
  min-height: 170px;
  background-color: ${({ theme }) => theme.colors.white};

  & .hefesto-simple-graph--success {
    .hefesto-simple-graph__bar {
      background-color: #b84232;
    }
  }
`;

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-content: space-between;
  gap: 24px;
  flex-wrap: wrap;

  & .hefesto-tag {
    height: 24px;
    align-self: center;
  }
  & .hefesto-keyvalueitem {
    width: 172px;
  }
  & .hefesto-title,
  .hefesto-keyvalueitem__value {
    display: flex;
    flex-wrap: nowrap;
    width: max-content;
  }
  .hefesto-simple-graph__bar-wrapper {
    min-width: 172px;
  }
  & h2 {
    margin: 0;
  }
  & > button {
    align-self: flex-end;
  }
`;

export const AlertText = styled.span`
  color: #e04226;
  font-size: 1rem;
`;

export const NormalText = styled.span`
  color: #66696b;
  font-size: 1rem;
`;
